<i18n>
{
  "fr": {
    "select-pleaseChoose": "Choisir...",
    "logtype-storage-opened": "Ouverture du stockage",
    "logtype-reminder": "Relance",
    "log-type-label": "Type d'événement",
    "message-label": "Votre message",
    "new-event-label": "Ajouter une communication",
    "add-message-title": "Nouveau message",
    "create-log-label": "Envoyer",
    "logtype-communication": "Communication",
    "required-field": "Ce champs est requis",
    "notifyByEmail-label": "Envoyer une copie au requérant",
    "set-status-before-new-event": "Veuillez passer à l'étape deux pour pouvoir ajouter une communication."
  }
}
</i18n>

<template>

  <div class="log-form-card">

    <md-card v-on:click.native="openForm" :class="!isOpen ? 'clickable' : ''">
      <md-ripple>
        <md-card-header>
          <div v-if="isOpen" class="md-title" v-html="$t('add-message-title')"></div>
          <div class="open-form-icon" v-if="!isOpen && !isDisabled"><md-icon>add_circle_outline</md-icon><span class="open-form-text">{{ $t('new-event-label') }}</span></div>
          <div class="open-form-icon info" v-if="isDisabled"><md-icon>info</md-icon><span class="open-form-text"><i>{{ $t('set-status-before-new-event') }}</i></span></div>
        </md-card-header>

        <md-card-content v-if="isOpen">
            <!--
            <md-field :class="getValidationClass('type')">
              <label>{{ $t('log-type-label') }}</label>
              <md-select v-model="log.type" required>
                <md-option value="">{{ $t('select-pleaseChoose') }}</md-option>
                <md-option value="communication">{{ $t('logtype-communication') }}</md-option>
                <md-option value="storage-opened">{{ $t('logtype-storage-opened') }}</md-option>
                <md-option value="reminder">{{ $t('logtype-reminder') }}</md-option>
              </md-select>
              <span class="md-error" v-if="!$v.log.type.required">{{ $t('required-field') }}</span>
            </md-field>
            -->
            <md-field :class="getValidationClass('value', 'message')">
              <label>{{ $t('message-label') }}</label>
              <md-textarea v-model="log.value.message" md-autogrow required></md-textarea>
              <span class="md-error" v-if="!$v.log.value.message.required">{{ $t('required-field') }}</span>
            </md-field>

            <md-checkbox v-if="enableNotifyEmail" v-model="log.value.notifyByEmail" >{{ $t('notifyByEmail-label') }}</md-checkbox>

            <md-card-actions>
              <md-button class="md-primary md-raised" @click.native="createLog">{{ $t('create-log-label') }}</md-button>
            </md-card-actions>

        </md-card-content>
      </md-ripple>
    </md-card>

  </div>

</template>

<script>

import { validationMixin } from 'vuelidate'
import _ from 'lodash'

import {
  required
} from 'vuelidate/lib/validators'

export default {
  name: 'LogForm',
  props: {
    log: {
      type: Object,
      default: () => {
        return {
          type: 'communication',
          value: {}
        }
      }
    },
    isOpen: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    log: {
      type: {
        required
      },
      value: {
        message: {
          required
        }
      }
    }
  },
  event: 'submit',
  data () {
    this.$i18n.locale = 'fr'
    return {

    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  computed: {
    enableNotifyEmail () {
      return this.log.type === 'communication'
    }
  },
  methods: {
    getValidationClass (rootName, fieldName) {
      const field = typeof fieldName === 'undefined' ? this.$v.log[rootName] : this.$v.log[rootName][fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    openForm () {
      if (!this.isDisabled) {
        this.isOpen = true
      }
    },
    createLog () {
      this.$v.log.$touch()
      if (!this.$v.log.$invalid) {
        this.$emit('submit', _.clone(this.log))
      }
    }
  }
}
</script>

<style lang="scss">
  .log-form-card {
    padding: 5px;
  }
  .open-form-icon {
    margin: 0 auto;
    display: block;
    margin-top: 10px;

    &.info {
      display: flex;
    }
  }
  .open-form-text {
    font-size: 15px;
    margin-left: 8px;
  }
</style>
